<template>
    <div class="container">
        <div class="row">
            <div class="col-xl-3 col-lg-12" v-html="content"></div>
            <div class="col-xl-9 col-lg-12">
                <iframe src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d1872.2718696053757!2d73.36050530164741!3d54.990549667862766!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x43aafe1e4d0e1e83%3A0x6af2c6ee26af13e!2z0YPQuy4g0J_QtdCy0YbQvtCy0LAsIDcsINCe0LzRgdC6LCDQntC80YHQutCw0Y8g0L7QsdC7LiwgNjQ0MDQz!5e0!3m2!1sru!2sru!4v1526559608071" width="100%" height="600" frameborder="0" style="border:0" allowfullscreen></iframe>
            </div>
        </div>
    </div>
</template>

<script>
    var marked = require("marked")
    marked.setOptions({
        headerIds: false
    });

    import content from '../pages_content/contacts.md';

    export default {
        name: 'Contacts',
        data() {
            return {
                content: this.md(content)
            }
        },
        methods: {
            md: function(val){
                return marked(val);
            }
        }
    }
</script>

<style scoped>
    .container {
        margin-top: 115px;
    }
</style>


// WEBPACK FOOTER //
// src/components/pages/Contacts.vue